export default {"src":"/_next/static/media/KMI.ee29d364.svg","height":18,"width":18};